export enum CreateStorageInboundLoader {
  LoadStorageInboundCreateDraft = "LoadStorageInboundCreateDraft",
  UpdateStorageInboundLoader = "UpdateStorageInboundLoader",
  LoadStorageInboundCasePacks = "LoadStorageInboundCasePacks",
}
